// import React, { useContext, useState, useEffect } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ReferenceLine,
//   // LabelList
// } from "recharts";
// import "./StackChartExpen.scss";
// import { AppContext } from "../../../context/Context";

// const StackChartExpense = ({ datas }) => {
//   const { dataRange, clearState } = useContext(AppContext);
//   const [active, setActive] = useState();

//   useEffect(() => {
//     if (dataRange === "All") {
//       if (clearState === "") {
//         setActive(true);
//         console.log("testtrue");
//       } else if (clearState === null) {
//         console.log("run else if");

//         setTimeout(() => {
//           setActive(true);
//         }, 950);
//       } else {
//         setActive(false);
//         console.log("testtrue");
//       }
//     } else {
//       if (clearState !== "") {
//         setTimeout(() => {
//           setActive(true);
//         }, 950);
//       }
//     }
//   }, [setActive, dataRange, clearState]);

//   const data = datas.map((item, index) => {
//     return {
//       ...item,
//       holdings: item.revenue,
//       totalRevenue: item.revenue + (item.greenIncrease || 0),
//     };
//   });
//   // CustomTooltip.jsx
//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const item = payload[0].payload;
//       return (
//         <div className="tooltip-containers">
//           <p className="tooltip-title">{item.month}</p>
//           <p className="tooltip-value">
//             Hodlings:
//             {item.holdings.toLocaleString("en-US", {
//               style: "currency",
//               currency: "USD",
//             })}
//           </p>

//           {item.greenIncrease && (
//             <div className="tooltip-increase">
//               <span></span>
//               <p>
//                 States:
//                 {item.greenIncrease.toLocaleString("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 })}
//               </p>
//             </div>
//           )}

//           {item.yellowdecrease ? (
//             <div className="tooltip-decrease">
//               <span></span>

//               <p>
//                 OnBoarding Fee: -
//                 {item.yellowdecrease.toLocaleString("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 })}
//               </p>
//             </div>
//           ) : (
//             ""
//           )}
//         </div>
//       );
//     }
//     return null;
//   };

//   const CustomBar = (props) => {
//     const { x, y, width, height, index } = props;
//     const item = data[index];

//     // Get the maximum value from your data for dynamic scaling
//     const maxValue = Math.max(
//       ...data.map((item) => item.revenue + (item.greenIncrease || 0))
//     );

//     // Scale the greenHeight dynamically based on maxValue and chart height
//     let greenHeight = item.greenIncrease
//       ? (item.greenIncrease / maxValue) * height
//       : 0;

//     return (
//       <g>
//         <defs>
//           <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="0%" stopColor="#FFC1C1" stopOpacity={1} />
//             <stop offset="100%" stopColor="#F08080" stopOpacity={1} />
//           </linearGradient>
//           <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="0%" stopColor="#FFE7D2" stopOpacity={1} />
//             <stop offset="100%" stopColor="#FFDAB9" stopOpacity={1} />
//           </linearGradient>
//         </defs>

//         {/* Main revenue bar */}
//         <rect
//           x={x}
//           y={y}
//           width={width}
//           height={height}
//           fill="url(#colorBlue)"
//           style={{ cursor: "pointer" }}
//         />

//         {/* Green increase should go on top */}
//         {greenHeight > 0 && (
//           <rect
//             x={x}
//             y={y - greenHeight}
//             width={width}
//             height={greenHeight}
//             fill="url(#colorGreen)"
//             style={{ cursor: "pointer" }}
//           />
//         )}

//         {/* Label displaying the total value at the top of the column */}
//         <text
//           x={x + width / 2}
//           y={y - greenHeight - 5}
//           fill="gray"
//           fontSize="14"
//           fontWeight="bold"
//           textAnchor="middle"
//         >
//           ${(item.totalRevenue / 1000000).toFixed(2)}M
//         </text>
//       </g>
//     );
//   };

//   console.log(active);

//   return (
//     <div style={{ width: "100%", height: 450 }}>
//       <ResponsiveContainer width="100%" height="100%">
//         <BarChart
//           data={data}
//           margin={{ top: 90, right: 30, left: 20, bottom: 20 }}
//           barSize={50}
//         >
//           <CartesianGrid
//             vertical={false}
//             strokeDasharray="3 3"
//             horizontal={true}
//           />
//           <XAxis dataKey="month" axisLine={false} tick={{ fontSize: 15 }} />
//           <YAxis
//             tickFormatter={(value) => `$${(value / 1000000).toFixed(2)}M`}
//             domain={[0, 150000]}
//             axisLine={false}
//             tick={{ fontSize: 15 }}
//           />
//           <ReferenceLine y={0} stroke="gray" />
//           <Tooltip cursor={false} content={<CustomTooltip />} />
//           {/* <Bar dataKey="totalRevenue" shape={<CustomBar />} cursor={'pointer'} /> */}
//           <Bar
//             dataKey="totalRevenue"
//             shape={<CustomBar />}
//             cursor={"pointer"}
//             isAnimationActive={active === true}
//             animateNewValues={active === true}
//           ></Bar>
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default StackChartExpense;

// import React, { useContext, useState, useEffect, useRef } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ReferenceLine,
// } from "recharts";
// import "./StackChartExpen.scss";
// import { AppContext } from "../../../context/Context";

// const StackChartExpense = ({ datas }) => {
//   const { dataRange, clearState } = useContext(AppContext);
//   const [active, setActive] = useState();

//   useEffect(() => {
//     if (dataRange === "All") {
//       if (clearState === "") {
//         setActive(true);
//         console.log("testtrue");
//       } else if (clearState === null) {
//         console.log("run else if");

//         setTimeout(() => {
//           setActive(true);
//         }, 950);
//       } else {
//         setActive(false);
//         console.log("testtrue");
//       }
//     } else {
//       if (clearState !== "") {
//         setTimeout(() => {
//           setActive(true);
//         }, 950);
//       }
//     }
//   }, [setActive, dataRange, clearState]);

//   const data = datas.map((item, index) => {
//     return {
//       ...item,
//       holdings: item.revenue,
//       totalRevenue: item.revenue + (item.greenIncrease || 0),
//     };
//   });

//   // CustomTooltip component
//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const item = payload[0].payload;
//       return (
//         <div className="tooltip-containers">
//           <p className="tooltip-title">{item.month}</p>
//           <p className="tooltip-value">
//             Hodlings:
//             {item.holdings.toLocaleString("en-US", {
//               style: "currency",
//               currency: "USD",
//             })}
//           </p>

//           {item.greenIncrease && (
//             <div className="tooltip-increase">
//               <span></span>
//               <p>
//                 States:
//                 {item.greenIncrease.toLocaleString("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 })}
//               </p>
//             </div>
//           )}

//           {item.yellowdecrease ? (
//             <div className="tooltip-decrease">
//               <span></span>

//               <p>
//                 OnBoarding Fee: -
//                 {item.yellowdecrease.toLocaleString("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 })}
//               </p>
//             </div>
//           ) : (
//             ""
//           )}
//         </div>
//       );
//     }
//     return null;
//   };

//   // AnimatedCustomBar component with proper animation
//   const AnimatedCustomBar = (props) => {
//     const { x, y, width, height, index } = props;
//     const item = data[index];
//     const [animationProgress, setAnimationProgress] = useState(0);
//     const animationRef = useRef(null);

//     // Get the maximum value from your data for dynamic scaling
//     const maxValue = Math.max(
//       ...data.map((item) => item.revenue + (item.greenIncrease || 0))
//     );

//     // Scale the greenHeight dynamically based on maxValue and chart height
//     let fullGreenHeight = item.greenIncrease
//       ? (item.greenIncrease / maxValue) * height
//       : 0;

//     // Apply animation progress
//     const currentHeight = height * animationProgress;
//     const greenHeight = fullGreenHeight * animationProgress;

//     // Animation effect
//     useEffect(() => {
//       if (active) {
//         // Clear any existing animation
//         if (animationRef.current) {
//           cancelAnimationFrame(animationRef.current);
//         }

//         let startTime = null;
//         const duration = 800; // Animation duration in ms

//         // Animation function
//         const animate = (timestamp) => {
//           if (!startTime) startTime = timestamp;
//           const elapsed = timestamp - startTime;
//           const progress = Math.min(elapsed / duration, 1);

//           setAnimationProgress(progress);

//           if (progress < 1) {
//             animationRef.current = requestAnimationFrame(animate);
//           }
//         };

//         // Start animation
//         animationRef.current = requestAnimationFrame(animate);
//       } else {
//         setAnimationProgress(0);
//       }

//       // Cleanup function
//       return () => {
//         if (animationRef.current) {
//           cancelAnimationFrame(animationRef.current);
//         }
//       };
//     }, [active]);

//     return (
//       <g>
//         <defs>
//           <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="0%" stopColor="#FFC1C1" stopOpacity={1} />
//             <stop offset="100%" stopColor="#F08080" stopOpacity={1} />
//           </linearGradient>
//           <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="0%" stopColor="#FFE7D2" stopOpacity={1} />
//             <stop offset="100%" stopColor="#FFDAB9" stopOpacity={1} />
//           </linearGradient>
//         </defs>

//         {/* Main revenue bar with animation */}
//         <rect
//           x={x}
//           y={y + height - currentHeight}
//           width={width}
//           height={currentHeight}
//           fill="url(#colorBlue)"
//           style={{ cursor: "pointer" }}
//         />

//         {/* Green increase should go on top with animation */}
//         {fullGreenHeight > 0 && (
//           <rect
//             x={x}
//             y={y - greenHeight}
//             width={width}
//             height={greenHeight}
//             fill="url(#colorGreen)"
//             style={{ cursor: "pointer" }}
//           />
//         )}

//         {/* Label displaying the total value at the top of the column */}
//         <text
//           x={x + width / 2}
//           y={y - greenHeight - 5}
//           fill="gray"
//           fontSize="14"
//           fontWeight="bold"
//           textAnchor="middle"
//           opacity={animationProgress}
//         >
//           ${(item.totalRevenue / 1000000).toFixed(2)}M
//         </text>
//       </g>
//     );
//   };

//   return (
//     <div style={{ width: "100%", height: 450 }}>
//       <ResponsiveContainer width="100%" height="100%">
//         <BarChart
//           data={data}
//           margin={{ top: 90, right: 30, left: 20, bottom: 20 }}
//           barSize={50}
//         >
//           <CartesianGrid
//             vertical={false}
//             strokeDasharray="3 3"
//             horizontal={true}
//           />
//           <XAxis dataKey="month" axisLine={false} tick={{ fontSize: 15 }} />
//           <YAxis
//             tickFormatter={(value) => `$${(value / 1000000).toFixed(2)}M`}
//             domain={[0, 150000]}
//             axisLine={false}
//             tick={{ fontSize: 15 }}
//           />
//           <ReferenceLine y={0} stroke="gray" />
//           <Tooltip cursor={false} content={<CustomTooltip />} />
//           <Bar
//             dataKey="totalRevenue"
//             shape={<AnimatedCustomBar />}
//             cursor={"pointer"}
//             isAnimationActive={false} // We handle animation ourselves
//           />
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default StackChartExpense;

import React, { useContext, useState, useEffect, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import "./StackChartExpen.scss";
import { AppContext } from "../../../context/Context";

const StackChartExpense = ({ datas }) => {
  const { dataRange, clearState } = useContext(AppContext);
  const [active, setActive] = useState();

  useEffect(() => {
    // if (dataRange === "All") {
    //   if (clearState === "") {
    //     setActive(true);
    //     // console.log("testtrue");
    //   } else if (clearState === null) {
    //     // console.log("run else if");

    //     setTimeout(() => {
    //       setActive(true);
    //     }, 900);
    //   } else {
    //     setActive(false);
    //     // console.log("testtrue");
    //   }
    // } else {
    //   if (clearState !== "") {
    //     setTimeout(() => {
    //       setActive(true);
    //     }, 900);
    //   }
    // }
    setActive(true)
  }, [setActive, dataRange, clearState]);

  const data = datas.map((item, index) => {
    return {
      ...item,
      holdings: item.revenue,
      totalRevenue: item.revenue + (item.greenIncrease || 0),
    };
  });

  // CustomTooltip component
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="tooltip-containers">
          <p className="tooltip-title">{item.month}</p>
          <p className="tooltip-value">
            Hodlings:
            {item.holdings.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>

          {item.greenIncrease && (
            <div className="tooltip-increase">
              <span></span>
              <p>
                States:
                {item.greenIncrease.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
            </div>
          )}

          {item.yellowdecrease ? (
            <div className="tooltip-decrease">
              <span></span>

              <p>
                OnBoarding Fee: -
                {item.yellowdecrease.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }
    return null;
  };

  // AnimatedCustomBar component with sequential animation
  const AnimatedCustomBar = (props) => {
    const { x, y, width, height, index } = props;
    const item = data[index];
    const [mainBarProgress, setMainBarProgress] = useState(0);
    const [greenBarProgress, setGreenBarProgress] = useState(0);
    const [labelOpacity, setLabelOpacity] = useState(0);
    const animationRef = useRef(null);

    // Get the maximum value from your data for dynamic scaling
    const maxValue = Math.max(
      ...data.map((item) => item.revenue + (item.greenIncrease || 0))
    );

    // Scale the greenHeight dynamically based on maxValue and chart height
    let fullGreenHeight = item.greenIncrease
      ? (item.greenIncrease / maxValue) * height
      : 0;

    // Apply animation progress
    const currentHeight = height * mainBarProgress;
    const greenHeight = fullGreenHeight * greenBarProgress;

    // Animation effect
    useEffect(() => {
      if (active) {
        // Clear any existing animation
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }

        let startTime = null;
        const mainBarDuration = 600; // Main bar animation duration in ms
        const greenBarDuration = 400; // Green bar animation duration in ms
        const totalDuration = mainBarDuration + greenBarDuration;

        // Animation function
        const animate = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;

          // First animate the main bar
          if (elapsed < mainBarDuration) {
            const progress = Math.min(elapsed / mainBarDuration, 1);
            setMainBarProgress(progress);
          }
          // Then animate the green bar
          else if (elapsed < totalDuration) {
            setMainBarProgress(1); // Ensure main bar is complete
            const greenElapsed = elapsed - mainBarDuration;
            const greenProgress = Math.min(greenElapsed / greenBarDuration, 1);
            setGreenBarProgress(greenProgress);
            setLabelOpacity(greenProgress); // Label appears with green bar
          }
          // Animation complete
          else {
            setMainBarProgress(1);
            setGreenBarProgress(1);
            setLabelOpacity(1);
          }

          if (elapsed < totalDuration) {
            animationRef.current = requestAnimationFrame(animate);
          }
        };

        // Start animation
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setMainBarProgress(0);
        setGreenBarProgress(0);
        setLabelOpacity(0);
      }

      // Cleanup function
      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    }, [active]);

    return (
      <g>
        <defs>
          <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFC1C1" stopOpacity={1} />
            <stop offset="100%" stopColor="#F08080" stopOpacity={1} />
          </linearGradient>
          <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFE7D2" stopOpacity={1} />
            <stop offset="100%" stopColor="#FFDAB9" stopOpacity={1} />
          </linearGradient>
        </defs>

        {/* Main revenue bar with animation */}
        <rect
          x={x}
          y={y + height - currentHeight}
          width={width}
          height={currentHeight}
          fill="url(#colorBlue)"
          style={{ cursor: "pointer" }}
        />

        {/* Green increase should go on top with animation */}
        {fullGreenHeight > 0 && (
          <rect
            x={x}
            y={y - greenHeight}
            width={width}
            height={greenHeight}
            fill="url(#colorGreen)"
            style={{ cursor: "pointer" }}
          />
        )}

        {/* Label displaying the total value at the top of the column */}
        <text
          x={x + width / 2}
          y={y - greenHeight - 5}
          fill="gray"
          fontSize="14"
          fontWeight="bold"
          textAnchor="middle"
          opacity={labelOpacity}
        >
          ${(item.totalRevenue / 1000000).toFixed(2)}M
        </text>
      </g>
    );
  };

  return (
    <div style={{ width: "100%", height: 450 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 90, right: 30, left: 20, bottom: 20 }}
          barSize={50}
        >
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
            horizontal={true}
          />
          <XAxis dataKey="month" axisLine={false} tick={{ fontSize: 15 }} />
          <YAxis
            tickFormatter={(value) => `$${(value / 1000000).toFixed(2)}M`}
            domain={[0, 150000]}
            axisLine={false}
            tick={{ fontSize: 15 }}
          />
          <ReferenceLine y={0} stroke="gray" />
          <Tooltip cursor={false} content={<CustomTooltip />} />
          <Bar
            dataKey="totalRevenue"
            shape={<AnimatedCustomBar />}
            cursor={"pointer"}
            isAnimationActive={false} // We handle animation ourselves
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackChartExpense;
